import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getSoyMultipliersFromAPI = async ({ zoneId }) => {
    try {
        const apiUrl = new URL(
            zoneId
                ? `${settings.urls.apiDomain}/core/v1/soy/multipliers/?zone=${zoneId}`
                : `${settings.urls.apiDomain}/core/v1/soy/multipliers`,
            window.location.origin
        );
        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    } catch (error) {
        return [];
    }
};

export const getSoyMultiplierItemFromAPI = async ({ id }) => {
    try {
        const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/soy/multipliers/${id}/`, window.location.origin);
        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    } catch (error) {
        return {};
    }
};

export const getSoyMultiplierItemsFromAPI = async ({ ids }) => {
    try {
        const allFeaturesPromises = [];
        for (const id of ids) {
            allFeaturesPromises.push(getSoyMultiplierItemFromAPI({ id }));
        }

        const allFeatures = await Promise.all(allFeaturesPromises);

        return allFeatures;
    } catch (error) {
        return [];
    }
};

export const getSoyMultiplierZonesFromAPI = async ({ country }) => {
    try {
        const apiUrl = new URL(
            `${settings.urls.apiDomain}/core/v1/soy/multipliers/zones/?country=${country.code}`,
            window.location.origin
        );
        const res = await axFetch.get(apiUrl.toString());
        return res.data;
    } catch (error) {
        return [];
    }
};
